import { Button, Col, Empty, Input, Pagination, Row, message } from 'antd'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import React, { Fragment, memo, useCallback, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
import { withRouter } from 'react-router-dom'
import TableComponent from '../../components/Common/TableComponent'
import PageTitle from '../../components/PageTitle'
import UnreadText from '../../components/UnreadText/UnreadText'
import { systemName } from '../../config'
import {
  ACL_ACTION_TYPE,
  DATE_FORMAT_DEFAULT,
  DOCUMENT_STATUS,
  MODULE_CODE,
} from '../../constants'
import DocumentsLayout from '../../layouts/DocumentsLayout'
import {
  SearchBar,
  TableFooterActionWrapper,
} from './CateDocumentOutgoingDocPageStyled'
import UnreadTextOutGoing from '../../components/UnreadText/UnreadTextOutGoing'

const { Search } = Input

const CateDocumentOutgoingDocPage = props => {
  const {
    history,
    authenticationStore,
    cateDocumentStore,
    moduleStore,
    aclStore,
  } = props

  const { currentUser } = authenticationStore
  const { isSuperAdmin, isAccountAdmin } = authenticationStore

  const { aclActionsByUser } = aclStore
  const { isAccessControl } = moduleStore

  const SCROLL_WIDTH = 1000

  const [list, setList] = useState([])
  const [total, setTotal] = useState(0)
  let [searchOptionTitle, setSearchOptionTitle] = useState('')
  let [searchOption, setSearchOption] = useState({
    bussiness_doc_type: undefined,
    status: undefined,
    title: undefined,
    page: 0,
    size: 10,
  })
  const [tableLoading, setTableLoading] = useState(false)
  // check hiển thị phân trang khi load dữ liệu
  const [checkPagination, setCheckPagination] = useState(true)

  const tableColumns = [
    {
      title: 'Số ký hiệu',
      width: 130,
      render: record => (
        <UnreadTextOutGoing
          text={record.documentNumber}
          isUnread={checkUnread(record)}
          width={130}
        />
      ),
    },
    {
      title: 'Tiêu đề',
      width: 400,
      render: record => (
        <UnreadTextOutGoing
          text={record.subject}
          isUnread={checkUnread(record)}
          width={400}
        />
      ),
    },
    {
      title: 'Nơi nhận',
      width: 200,
      render: record => {
        return (
          record.organs &&
          record.organs.map((organ, index) => {
            return (
              <div key={index}>
                {' '}
                <UnreadTextOutGoing
                  text={organ?.organName}
                  isUnread={checkUnread(record)}
                  width={200}
                />
              </div>
            )
          })
        )
      },
    },
    {
      title: 'Trạng thái',
      width: 80,
      render: record => (
        <UnreadTextOutGoing
          text={DOCUMENT_STATUS[record?.statusId]?.value}
          isUnread={checkUnread(record)}
          width={80}
        />
      ),
    },
    {
      title: 'Ngày gửi',
      width: 80,
      render: record =>
        record.sendDate ? (
          <UnreadTextOutGoing
            text={moment(record.sendDate).format(DATE_FORMAT_DEFAULT)}
            isUnread={checkUnread(record)}
            width={80}
          />
        ) : null,
    },
  ]

  const checkUnread = record => record.statusId == 1

  const onQuickSearch = useCallback(title => {
    let newSearchOption = {
      ...searchOption,
      ...{
        page: 0,
        title: title ? title.trim() : undefined,
      },
    }
    setSearchOption(newSearchOption)
  }, [])

  const onChangePagination = useCallback(
    pageIndex => {
      let newSearchOption = {
        ...searchOption,
        ...{
          page: pageIndex - 1,
        },
      }
      setSearchOption(newSearchOption)
    },
    [searchOption]
  )

  useEffect(() => {
    fetchData()
  }, [currentUser, searchOption, aclActionsByUser])

  const fetchData = useCallback(async () => {
    if (!currentUser) return
    if (aclActionsByUser.length === 0) return
    if (
      !isSuperAdmin &&
      !isAccountAdmin &&
      !isAccessControl(
        MODULE_CODE.lien_thong_vnpt,
        ACL_ACTION_TYPE.menu__VNPT,
        aclActionsByUser
      )
    ) {
      history.push('/dashboard')
      message.error(
        'Bạn không có quyền truy cập trang này, vui lòng liên hệ admin'
      )
      return
    }
    setTableLoading(true)
    await setCheckPagination(false)
    cateDocumentStore
      .getDocumentsOutgoing(searchOption)
      .then(res => {
        setList(res.data.data)
        setTotal(res.data.total_count)
      })
      .finally(() => {
        setTableLoading(false)
        setCheckPagination(true)
      })
  }, [currentUser, searchOption, aclActionsByUser])

  return (
    <DocumentsLayout
      title={
        <PageTitle location={props.location} title="Văn bản đi" hiddenGoBack>
          <Button
            onClick={() => {
              history.push('/cate-document/outgoing-document/create')
            }}
            type={'primary'}>
            Tạo mới văn bản đi
          </Button>
        </PageTitle>
      }
      selectedKey="outgoing-document"
      linkToIncomingDocument="/cate-document/incoming-document"
      linkToOutgoingDocument="/cate-document/outgoing-document"
      linkToConnectedCommitteeOrg="/cate-document/organization">
      <Helmet>
        <title>Văn bản đi | {systemName} Trục liên thông</title>
      </Helmet>
      <Fragment>
        <Row>
          <Col span={12}>
            <SearchBar>
              <Search
                allowClear
                onSearch={onQuickSearch}
                defaultValue={''}
                placeholder={'Tìm kiếm văn bản theo trích yếu'}
                onChange={e => {
                  setSearchOptionTitle(e.target.value)
                }}
                value={searchOptionTitle}
              />
            </SearchBar>
          </Col>
        </Row>
        <TableComponent
          onRow={record => {
            return {
              onClick: () =>
                history.push(
                  `/cate-document/outgoing-document/view/${record.id}`
                ),
            }
          }}
          rowKey={record => record.code}
          dataSource={list}
          columns={tableColumns}
          pagination={false}
          scroll={{ x: SCROLL_WIDTH }}
          locale={{
            emptyText:
              checkPagination === true ? (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description={'Không có dữ liệu'}
                />
              ) : (
                <div style={{ opacity: 0.1, height: '150px' }} />
              ),
          }}
          loading={tableLoading}
        />
        <TableFooterActionWrapper>
          {checkPagination === true ? (
            <Pagination
              onChange={e => onChangePagination(e)}
              pageSize={searchOption.size}
              showSizeChanger={false}
              showLessItems
              current={searchOption.page + 1}
              total={total}
              hideOnSinglePage={true}
            />
          ) : (
            ''
          )}
        </TableFooterActionWrapper>
      </Fragment>
    </DocumentsLayout>
  )
}

CateDocumentOutgoingDocPage.propTypes = {}

export default memo(
  withRouter(
    inject(
      'cateDocumentStore',
      'authenticationStore',
      'moduleStore',
      'aclStore'
    )(observer(CateDocumentOutgoingDocPage))
  )
)
